import {jsxs as $abhV9$jsxs, jsx as $abhV9$jsx} from "react/jsx-runtime";
import $abhV9$classnames from "classnames";
import "react";
import {CloseGray as $abhV9$CloseGray} from "@komponentkassen/svv-icons";
import {SVVConditionalWrapper as $abhV9$SVVConditionalWrapper} from "@komponentkassen/svv-layout";






function $6bbf7f1cc11bb310$var$messageModifierClass(type) {
    switch(type){
        case "error":
            return "svv-alert--error";
        case "warning":
            return "svv-alert--warning";
        case "info":
            return "svv-alert--info";
        case "success":
            return "svv-alert--success";
        case "infoMessage":
            return "svv-alert--infomessage";
        default:
            return "svv-alert--continousText";
    }
}
const $6bbf7f1cc11bb310$var$CloseButton = ({ onDismiss: onDismiss , closeText: closeText  })=>/*#__PURE__*/ (0, $abhV9$jsxs)("button", {
        className: "svv-alert__close-button",
        type: "button",
        onClick: onDismiss,
        children: [
            /*#__PURE__*/ (0, $abhV9$jsx)((0, $abhV9$CloseGray), {
                "aria-hidden": true,
                className: "svv-alert__close_icon"
            }),
            /*#__PURE__*/ (0, $abhV9$jsx)("span", {
                className: (0, $abhV9$classnames)("svv-alert__close-button--text", !closeText && "svv-alert__close-button--text-hidden"),
                children: closeText || "Lukk"
            })
        ]
    });
function $6bbf7f1cc11bb310$export$1e8d32ae08d325b0({ type: type , isCenter: isCenter , isFullWidth: isFullWidth , className: className , children: children , heading: heading , closeText: closeText = "" , size: size = "md" , onDismiss: onDismiss , headingLevel: headingLevel = "h2"  }) {
    const modifierClass = $6bbf7f1cc11bb310$var$messageModifierClass(type);
    const Heading = headingLevel;
    return /*#__PURE__*/ (0, $abhV9$jsx)("div", {
        className: (0, $abhV9$classnames)("svv-alert", `svv-alert--${size}`, modifierClass, {
            "svv-alert--center": isCenter,
            "svv-alert--fullWidth": isFullWidth,
            "svv-alert--padded": onDismiss
        }, className),
        children: /*#__PURE__*/ (0, $abhV9$jsxs)("div", {
            className: "svv-alert__content",
            children: [
                /*#__PURE__*/ (0, $abhV9$jsx)((0, $abhV9$SVVConditionalWrapper), {
                    condition: !!heading,
                    renderWrapper: ()=>/*#__PURE__*/ (0, $abhV9$jsxs)("div", {
                            className: "svv-alert__header",
                            children: [
                                /*#__PURE__*/ (0, $abhV9$jsx)(Heading, {
                                    className: "svv-alert__heading",
                                    children: heading
                                }),
                                onDismiss && /*#__PURE__*/ (0, $abhV9$jsx)($6bbf7f1cc11bb310$var$CloseButton, {
                                    onDismiss: onDismiss,
                                    closeText: closeText
                                })
                            ]
                        }),
                    children: onDismiss && /*#__PURE__*/ (0, $abhV9$jsx)($6bbf7f1cc11bb310$var$CloseButton, {
                        onDismiss: onDismiss,
                        closeText: closeText
                    })
                }),
                children
            ]
        })
    });
}




export {$6bbf7f1cc11bb310$export$1e8d32ae08d325b0 as SVVAlert};
//# sourceMappingURL=module.js.map
